import React from "react";
import AssesmentComponent from "../Component";

export default function Assesment() {
  return <AssesmentComponent />;
}
